import React from 'react';
import { hot } from 'react-hot-loader';
import { Route, Switch } from 'react-router-dom';

import HomeRoute, { baseUrl as homeUrl} from './modules/Home/Routes';
import AboutRoute, { baseUrl as aboutUrl } from './modules/About/Routes';
import LoginRoutes, { baseUrl as loginBaseUrl } from './modules/Login/Routes';
import ViewerRoutes, { baseUrl as viewerBaseUrl } from './modules/Viewer/Routes';
import InquiryRoutes, { baseUrl as inquiryBaseUrl } from './modules/Inquiry/Routes';
import ChangePasswordRoute, { baseUrl as changePasswordBaseUrl } from './modules/ChangePassword/Routes';
import ReissuePasswordRoute, { baseUrl as reissuePasswordBaseUrl } from './modules/ReissuePassword/Routes';

const Pages = () => {
  return (
    <Switch>
      <Route exact path={aboutUrl} component={AboutRoute} />
      <Route exact path={homeUrl} component={HomeRoute} />
      <Route exact path={loginBaseUrl} component={LoginRoutes} />
      <Route path={viewerBaseUrl} component={ViewerRoutes} />
      <Route path={inquiryBaseUrl} component={InquiryRoutes} />
      <Route exact path={changePasswordBaseUrl} component={ChangePasswordRoute} />
      <Route exact path={reissuePasswordBaseUrl} component={ReissuePasswordRoute} />
    </Switch>
  );
};

export default hot(module)(Pages);
